import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { ShipyardService } from "src/app/modules/shipyard/shipyard.service";
import { PriceyardService } from "src/app/modules/priceyard/services/priceyard.service";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-note-popup",
  templateUrl: "./note-popup.component.html",
  styleUrls: ["./note-popup.component.scss"],
})
export class NotePopupComponent implements OnInit,OnDestroy {
  notes = new FormControl("", Validators.required);
  spin: boolean = false;
  private destroy$ = new Subject<void>();
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<NotePopupComponent>,
    private snackBar: MatSnackBar,
    private shipyardService: ShipyardService,
    private priceyardService: PriceyardService
  ) {}

  ngOnInit(): void {
    if (this.data.userNote) {
      this.notes.setValue(this.data.userNote);
    }
  }
  close() {
    this.dialogRef.close();
  }

  action(e) {
    if (e === "Save") {
      this.save();
    } else if (e === "Cancel") {
      this.close();
    }
  }
  save() {
    this.spin = true;
   if(this.data?.isSkuNote){
    this.saveSkuNote();
   } else{
    const payload = {
      shipmentHeaderId: this.data.shipmentHeaderId,
      userNote: this.notes.value,
    };
    this.shipyardService.ShipmentUpdateUserNote(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: "User Notes updated successfully",
            action: "Dismiss",
            type: "success",
          },
        });

        this.dialogRef.close("Confirm");
      },
     error: (err) => {
        this.spin = false;
        const key = Object.keys(err.error.errors)[0];
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err.error.errors[key][0],
            action: "Dismiss",
            type: "error",
          },
        });
       }
   });
  }
}

  saveSkuNote() {
    let payload: any = {
      sku: [this.data.sku.sku],
      account: this.data.sku.account,
      note: this.notes.value,
    }
    this.priceyardService.EditNote(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.spin = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: "Sku Notes updated successfully",
            action: "Dismiss",
            type: "success",
          },
        });
        this.dialogRef.close("Confirm");
      },
      error: (err) => {
        this.spin = false;
        const key = Object.keys(err.error.errors)[0];
        this.snackBar.openFromComponent(SnackbarComponent, {
          duration: 3000,
          horizontalPosition: "center",
          data: {
            title: err.error.errors[key][0],
            action: "Dismiss",
            type: "error",
          },
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
